module.exports = __webpack_public_path__ + "static/media/Avatar8.2677abc1.png";